import { Fragment, h, render } from "preact";
import unwrapNodes from "../unwrapNodes";
import findCompatibleVariants from "../findCompatibleVariants";

export default function ProductCardPrice({
  product,
  variant,
  prefix = "product-card",
}) {
  console.log(`product`, product);
  if (!product.bundleProducts) {
    if (variant) {
      return (
        <span>
          {window.formatMoney(variant.priceV2.amount)}
          {variant.compareAtPriceV2 &&
          parseFloat(variant.compareAtPriceV2.amount) >
            parseFloat(variant.priceV2.amount) ? (
            <del className={`${prefix}__compare-price`}>
              {window.formatMoney(variant.compareAtPriceV2.amount)}
            </del>
          ) : null}
        </span>
      );
    } else {
      const compareAtPriceMin = parseFloat(
        product.compareAtPriceRange.minVariantPrice.amount,
      );
      const compareAtPriceMax = parseFloat(
        product.compareAtPriceRange.maxVariantPrice.amount,
      );
      const priceMin = parseFloat(product.priceRange.minVariantPrice.amount);
      const priceMax = parseFloat(product.priceRange.maxVariantPrice.amount);

      return (
        <span>
          {`${window.formatMoney(priceMin)}${priceMax > priceMin ? ` - ${window.formatMoney(priceMax)}` : ""}`}
          {compareAtPriceMax && compareAtPriceMax > priceMin ? (
            <del className={`${prefix}__compare-price`}>
              {`${window.formatMoney(compareAtPriceMin)}${compareAtPriceMax > compareAtPriceMin ? ` - ${window.formatMoney(compareAtPriceMax)}` : ""}`}
            </del>
          ) : null}
        </span>
      );
    }
  }

  const bundleProducts = unwrapNodes([
    ...product.bundleProducts.references.edges,
  ]);

  // compare at price is max of product price or product compare at price
  const compareAt = Math.max(
    parseFloat(product.priceRange.maxVariantPrice.amount),
    parseFloat(product.compareAtPriceRange.maxVariantPrice.amount),
    0,
  );

  const minComponentsPrice = bundleProducts.reduce(
    (total, bundleProduct) =>
      total + parseFloat(bundleProduct.priceRange.minVariantPrice.amount),
    0,
  );

  let calculatedComponentsPrice = 0;

  // Components may have cheaper options that aren't valid in this bundle so we need
  // to calculate the minimum valid bundle price
  if (product.compatibleModels || product.compatibleSizes) {
    const compatibleModels =
      product.compatibleModels &&
      JSON.parse(product.compatibleModels.reference.models.value);

    const compatibleSizes =
      product.compatibleSizes &&
      JSON.parse(product.compatibleSizes.reference.sizes.value);

    calculatedComponentsPrice = bundleProducts.reduce(
      (total, bundleProduct) => {
        if (bundleProduct.variants.length === 0)
          return (
            total + parseFloat(bundleProduct.priceRange.minVariantPrice.amount)
          );

        const { compatibleVariants } = findCompatibleVariants({
          variants: bundleProduct.variants,
          compatibleModels,
          compatibleSizes,
        });

        const cheapestVariant = compatibleVariants.sort(
          (a, b) => parseFloat(a.priceV2.amount) - parseFloat(b.priceV2.amount),
        )[0];

        return total + parseFloat(cheapestVariant.priceV2.amount);
      },
      0,
    );
  }

  const componentsPrice =
    calculatedComponentsPrice > 0
      ? calculatedComponentsPrice
      : minComponentsPrice;

  const currentPrice = Math.min(
    componentsPrice,
    parseFloat(product.priceRange.minVariantPrice.amount),
  );

  return (
    <span>
      {window.formatMoney(currentPrice)}
      {compareAt > currentPrice && (
        <del className={`${prefix}__compare-price`}>
          {window.formatMoney(compareAt)}
        </del>
      )}
    </span>
  );
}
